import React from 'react';

import CaptureIcon from '@atlaskit/icon/core/capture';
import { token } from '@atlaskit/tokens';

import type { FocusAreaIconProps } from './types';

export const STATUS_TO_COLOR_MAP = {
	pending: token('color.icon.accent.gray'),
	paused: token('color.icon.accent.gray'),
	on_track: token('color.icon.accent.lime'),
	at_risk: token('color.icon.warning'),
	off_track: token('color.icon.accent.red'),
	completed: token('color.icon.accent.gray'),
} as const;

export default function FocusAreaIcon({
	status,
	customColor,
	spacing,
	testId,
	label,
}: FocusAreaIconProps) {
	return (
		<CaptureIcon
			color={customColor || STATUS_TO_COLOR_MAP[status || 'pending']}
			spacing={spacing || 'none'}
			label={label || ''}
			testId={testId}
		/>
	);
}
